/**
 * The vocabulary both ends of the wire use to talk about who someone is.
 *
 * Kept in `shared` rather than in the API because the frontend renders decisions
 * from these same values — a role string that means one thing in Express and
 * another in React is how a contractor ends up seeing an admin menu.
 */
export const ROLES = ["SYSTEM_ADMIN", "UNIFIBER_INTERNAL", "EXTERNAL_OPERATOR"];
export const AUTH_TYPES = ["LOCAL", "ENTRA_ID", "BOTH"];
/**
 * What the sign-in endpoint tells the client to do next.
 *
 * The client never decides this for itself: every step but `AUTHENTICATED` comes
 * with a short-lived temp token that is only accepted by the endpoint for that one
 * step. A client that skipped ahead would simply be refused.
 */
export const LOGIN_STEPS = [
    "AUTHENTICATED",
    "TOTP_SETUP",
    "TOTP_VERIFY",
    "PASSWORD_EXPIRED",
];
/** True for the two internal Unifiber roles, which are never row-scoped. */
export function isInternal(role) {
    return role === "SYSTEM_ADMIN" || role === "UNIFIBER_INTERNAL";
}
/** True for roles that may reach the administration screens. */
export function isAdmin(role) {
    return role === "SYSTEM_ADMIN";
}
/**
 * THE contractor-scoping rule (cocon-stats hard rule 9).
 *
 * Returns `null` when the user sees every row, or the exact list of Monday
 * "Build contractor" labels they are limited to. The table, the KPI cards, the
 * charts and the export must all derive their filter from this one call, or they
 * drift apart and the report loses the one thing it exists to provide: the same
 * number for everybody.
 *
 * ⚠ An empty array is a real and meaningful answer — "this contractor is mapped to
 * no label, so no rows match". It must never be read as "no filter". That mistake
 * turns a misconfigured company into one that sees its competitors' work, which is
 * the single worst failure this application could have. `matchesScope` below exists
 * so no call site has to remember it.
 */
export function contractorScope(user) {
    return isInternal(user.role) ? null : user.mondayCompanyLabels;
}
/**
 * Whether one row's contractor label is visible under a scope.
 *
 * A row with no contractor set is visible to internal users only. No contractor may
 * claim a punch nobody has dispatched to them, and silently handing those rows to
 * everybody would be worse than leaving them unassigned.
 *
 * ⚠ Matching is exact: the board's own spelling, case and spaces included.
 */
export function matchesScope(rowContractor, scope) {
    if (scope === null)
        return true;
    if (rowContractor === null || rowContractor === undefined)
        return false;
    return scope.includes(rowContractor);
}
//# sourceMappingURL=auth.js.map